module.exports = __webpack_public_path__ + "media/application/images/play-697591c9168fb6c4c9b58daa12978a880edcf09f80519b4df66415fe0d5f3ee6.svg";